(function ($) {

  // ---------- APP START
  window.App = {

    config: {
      scrollOffset: 80
    },

    init: function () {
      // Init SVG polyfill
      if (typeof (svg4everybody) !== 'undefined') svg4everybody();

      // Init object-fill polyfill
      if (typeof (objectFitImages) !== 'undefined') objectFitImages();

      // Init Perfect Scrollbar
      document.querySelectorAll('.l-scrollbar').forEach(function($scrollbar) {
        new PerfectScrollbar($scrollbar, {
          suppressScrollX: true
        });
      });


      var $categorys = document.querySelectorAll('.js-category');
      if ($categorys.length) {
        $categorys.forEach(function ($category) {
          $category.addEventListener('click', function (e) {
            $(this).closest('form').trigger('submit');
          });
        });
      }


      // Init Clipboard
      var $copyBtns = document.querySelectorAll('.js-copy');
      if ($copyBtns.length) {
        var clipboard = new ClipboardJS('.js-copy');

        clipboard.on('success', function(e) {
          e.trigger.classList.add('is-copied');
          setTimeout(function () {
            e.trigger.classList.remove('is-copied');
          }, 1000);
        });
      }

      // Remove focus state when clicking on a button with a mouse
      $(':not(form) button, a').on('click', function (e) {
        if (e.clientX && e.clientY)
          $(this).trigger('blur');
      });

      // Scroll
      $('a[href^="#"]:not([href="#rgpd"])').on('click', function (e) {
        e.preventDefault();

        var scrollTo = $(this).data('scroll-to') ? $(this).data('scroll-to') : $(this).attr('href');

        if ($(scrollTo).length > 0 && $(this).data('prevent-scroll') !== true)
          App.scroll(scrollTo, $(this).data('scroll-offset'));

      });

      if ($('[data-scroll]').length) {
        App.scroll($('[data-scroll]').data('scroll'));
      }

      if (window.location.hash) {
        App.scroll(window.location.hash, App.config.scrollOffset);
      }

        // Magnific popup
        $('.js-mfp').magnificPopup({
            type: 'inline',
            preloader: false,
            focus: '.ss-search',
            callbacks: {
                open: function() {
                    init_select();
                }
            }
        });

        function init_select() {
            const selectElements = document.querySelectorAll('.js-select-choices:not(.slim-select)');
            selectElements.forEach((select) => {
                new SlimSelect({
                select: select,
                settings: {
                    shouldSort: false,
                }
                });
            });
        }
    },

    load: function () {},

    // Make div (with eventually child links) clickable
    initClickableDivs: function (context) {
      var clickableDivs;

      if (context === undefined) {
        clickableDivs = $('[data-href]');
      } else if (context.data('href')) {
        clickableDivs = context;
      } else {
        clickableDivs = context.find('[data-href]');
      }

      var enable = true;

      clickableDivs.click(function () {
        if (enable) {
          if ($(this).data('href-target') == '_blank') {
            window.open($(this).data('href'), '_blank');
          } else {
            document.location.href = $(this).data('href');
          }
        }
      }).find('a').click(function (e) {
        if (enable) {
          e.stopPropagation();
        }
      });
    },

    scroll: function (element, offset) {
      offset = offset === undefined ? App.config.scrollOffset : offset;

      $('html, body').animate({
        scrollTop: $(element).offset().top - offset
      }, 'slow');
    },

  };
  // ---------- APP END

  // Init app
  $(App.init);
  $(window).on('load', App.load);

})(jQuery);

(function(){
  $('form input[name=token]').each(function() {
      $(this).val($('meta[name=refresh]').attr('content'));
  });
})();
